import React from "react";
import { createTheme, LinearProgress, makeStyles, MuiThemeProvider } from "@material-ui/core";
import appStyle from "assets/jss/components/appStyle";
import { useLoaderEffect } from "hooks/useLoaderEffect";
import { defaultThemeCode, getTheme } from "utils/themes";

const useStyles = makeStyles(appStyle);

export const Loader = () => {
  const classes = useStyles();
  return <LinearProgress className={classes.progressBar} />;
};

const ApplicationLoader = () => {
  const loading = useLoaderEffect();
  return loading && <Loader />;
};

export default ApplicationLoader;

export const NoThemeLoader = () => (
  <MuiThemeProvider theme={createTheme(getTheme(defaultThemeCode))}>
    <LinearProgress
      style={{ height: 4, position: "absolute", zIndex: 2000, top: 0, left: 0, width: "100%", bottom: 0 }}
    />
  </MuiThemeProvider>
);
